import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "masonry" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }

import { ElInput, ElButton, ElIcon, ElDropdown, ElDropdownMenu, ElDropdownItem, ElMessageBox, ElMessage, ElEmpty, ElInfiniteScroll, ElScrollbar } from 'element-plus'
import { Folder, Search, Filter, FolderRemove, FolderOpened, Plus, ArrowLeft } from '@element-plus/icons-vue'
import { ref, computed, onMounted, nextTick, onBeforeUnmount, watch } from 'vue'
import { getResourceList } from '@/api/affairs'
import { useSdkStore } from '@/stores/sdk'


export default /*@__PURE__*/_defineComponent({
  __name: 'myUpload',
  props: {
  id: {
    type: Number,
    default: 0
  }
},
  setup(__props, { expose: __expose }) {

const sdkStore = useSdkStore()

const desginsdk = sdkStore.getSdk()
onMounted(() => {
  getList()

})

const props = __props
watch(() => props.id, (newVal, oldVal) => {
  if (newVal != oldVal) {
    pageNum.value = 1
    hasMore.value = true
    getList(false)
  }
})

const resourceList = ref([])
const scrollRef = ref<HTMLElement | null>(null)
const pageNum = ref(1)
const pageSize = ref(50)
const hasMore = ref(true)
const loadingMore = ref(false)
const totalPage = ref(0)
const getList = (append = false) => {
  if (append && loadingMore.value) return
  if (append) loadingMore.value = true
  getResourceList({
    page: pageNum.value, size: pageSize.value, file_type: 2, folder_id: props.id
  }).then(res => {
    const items = res?.data?.data?.items || []
    totalPage.value = res?.data?.data?.total_pages || 0

    if (append) {
      resourceList.value = (resourceList.value || []).concat(items)
    } else {
      resourceList.value = items
    }
    hasMore.value = items.length === pageSize.value
  }).finally(() => {
    loadingMore.value = false
  })
}

__expose({ getList })




const handleClick = (item: any) => {
  desginsdk.addElement.createImageElement(item.full_preview_url)
}
const onScroll = (e: string) => {
  console.log('totalPage', totalPage.value)
  if (pageNum.value >= totalPage.value) return
  if (e == 'bottom') {
    pageNum.value += 1
    getList(true)
  }
  // console.log('nearBottom', e)
  // const el = (e.target as HTMLElement) || scrollRef.value
  // if (!el || !hasMore.value || loadingMore.value) return
  // const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 16

  // if (nearBottom) {

  //   pageNum.value += 1
  //   getList(true)
  // }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElScrollbar), {
    height: "100%",
    onEndReached: onScroll,
    distance: "100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resourceList.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "masonry-item cursor-pointer"
          }, [
            _createElementVNode("div", {
              class: "masonry-content",
              onClick: ($event: any) => (handleClick(item))
            }, [
              _createElementVNode("img", {
                src: item.full_preview_url,
                alt: "",
                class: "media"
              }, null, 8, _hoisted_3)
            ], 8, _hoisted_2)
          ]))
        }), 128))
      ]),
      (resourceList.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(ElEmpty), { description: "暂无数据" })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})